
export const DBStores = {
    Carousel: {
    TableName: 'Carousel',
    Columns: 'id, ApplicationID, GifUrl, Message, HyperlinkUrl, StartDate, EndDate, IsActive, IsDeleted, CreatedBy, CreatedDate, UpdatedBy, UpdatedDate, application, locations',
    UsePaging:false
  },
};